const PbxxRecord = require('../pbxx_record')

module.exports = class Template extends PbxxRecord {
  static get class_name() {
    return 'Template'
  }
}
